export default "__VITE_ASSET__DNfb9VQh__"